import React from 'react'
import { Container, Row, Col, Button } from 'reactstrap'
import { withRouter } from 'react-router-dom'
import { I18n } from 'react-redux-i18n'
import { connect } from 'react-redux'
import { userIsAuthorized } from '../../../routes/Authorizer/helpers'
import SidePopup from '../../SidePopup'

const DelegationView = (props) => {
  const delegation = Object.values(props.delegations).filter((d) => props.match.params.id === d._id)[0]
  const brand = Object.values(props.brands).filter((b) => b._id === delegation.brand)[0]

  const hideModal = (e) => {
    if (e) e.preventDefault()
    props.history.goBack()
  }

  const handleEdit = () => props.history.push(`${props.match.url}/edit`)

  const { capabilities, user } = props

  let userCanManageDelegation = userIsAuthorized({
    capability: capabilities.delegations,
    action: 'UPDATE',
  })

  if (user.role === 'brandManager') {
    user.brands.forEach((userBrand) => {
      if (userBrand.id === brand._id) {
        if (userBrand.delegations.length === 0) {
          userCanManageDelegation = true
        } else {
          userCanManageDelegation = userBrand.delegations.includes(delegation._id)
        }
      }
    })
  }

  return (
    <SidePopup onHide={hideModal}>
      <Container>
        <Row className='mb-3'>
          <Col xs={12}>
            <div className='section-title'>{delegation.name}</div>
          </Col>
        </Row>
        <Row className='no-gutters'>
          <Col>
            <strong>{I18n.t('dashboard_city')}</strong>
          </Col>
          <Col>{delegation.city}</Col>
        </Row>
        <Row className='no-gutters'>
          <Col>
            <strong>{I18n.t('dashboard_province')}</strong>
          </Col>
          <Col>{delegation.province}</Col>
        </Row>
        <Row className='no-gutters'>
          <Col>
            <strong>{I18n.t('dashboard_country')}</strong>
          </Col>
          <Col>{delegation.country}</Col>
        </Row>
        <Row className='no-gutters'>
          <Col>
            <strong>{I18n.t('dashboard_brand')}</strong>
          </Col>
          <Col>{brand ? brand.name : I18n.t('delegation.noBrand')}</Col>
        </Row>
        <Row className='no-gutters mt-3'>
          {userCanManageDelegation && (
            <Col className='text-right'>
              <Button onClick={handleEdit} color='primary'>
                {I18n.t('dashboard_edit')}
              </Button>
            </Col>
          )}
        </Row>
      </Container>
    </SidePopup>
  )
}

export default connect((state) => ({
  delegations: state.delegations,
  brands: state.brands,
  user: state.user,
}))(withRouter(DelegationView))
